module.exports = __webpack_public_path__ + "media/military/military_gi_btn_hover-c00d84e4.png";